export default __webpack_public_path__ + "static/index_hero_01-d02cae183f5bfc95a88f52a1f40ca34c.jpg";